import { trends } from "@/mocks/opinion";

const trendIcon: Record<string, { icon: string; cls: string; text: string }> = {
  up: { icon: "ri-arrow-up-line", cls: "text-primary-600 bg-primary-100", text: "上升" },
  down: { icon: "ri-arrow-down-line", cls: "text-accent-700 bg-accent-100", text: "回落" },
  new: { icon: "ri-sparkling-2-fill", cls: "text-secondary-700 bg-secondary-200", text: "新上榜" },
};

function formatHeat(n: number) {
  if (n >= 1000000) return `${(n / 1000000).toFixed(1)}w`;
  if (n >= 1000) return `${Math.round(n / 1000)}k`;
  return String(n);
}

export default function RankingSection() {
  return (
    <section id="hot" className="bg-background-50">
      <div className="mx-auto max-w-6xl px-4 md:px-6 py-12 md:py-16">
        <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="inline-flex items-center gap-2 text-xs md:text-sm font-semibold uppercase tracking-widest text-primary-600">
              <span className="h-px w-6 bg-primary-500"></span> Trending
            </p>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl font-black text-foreground-950">今日热榜</h2>
            <p className="mt-2 max-w-xl text-sm md:text-base text-foreground-700">
              按讨论密度与互动热度实时滚动，帮你抓住此刻大家真正在围观什么。
            </p>
          </div>
          <p className="inline-flex items-center gap-1.5 text-xs text-foreground-600">
            <i className="ri-refresh-line text-base" aria-hidden="true"></i>
            每 15 分钟更新一次
          </p>
        </div>

        <ol className="mt-8 grid grid-cols-1 gap-3 md:gap-4">
          {trends.map((t) => {
            const meta = trendIcon[t.trend];
            return (
              <li
                key={t.rank}
                className="flex flex-col gap-3 sm:flex-row sm:items-center rounded-xl border border-background-200 bg-background-100/60 px-4 py-3.5 md:px-5 transition-colors hover:border-secondary-300 hover:bg-background-100"
              >
                <div className="flex items-center gap-4 sm:w-64 shrink-0">
                  <span
                    className={`font-heading text-2xl md:text-3xl font-black ${
                      t.rank === 1
                        ? "text-primary-500"
                        : t.rank === 2
                          ? "text-secondary-600"
                          : t.rank === 3
                            ? "text-accent-600"
                            : "text-foreground-300"
                    }`}
                  >
                    {String(t.rank).padStart(2, "0")}
                  </span>
                  <span className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs text-secondary-900">
                    <i className="ri-price-tag-3-line" aria-hidden="true"></i>
                    {t.tag}
                  </span>
                </div>

                <h3 className="flex-1 text-sm md:text-base font-medium leading-relaxed text-foreground-900 hover:text-primary-700">
                  <a href="#read" className="cursor-pointer">{t.title}</a>
                </h3>

                <div className="flex items-center gap-3 sm:gap-4 shrink-0">
                  <span className="hidden sm:inline-flex items-center gap-1 text-xs text-foreground-600">
                    <i className="ri-flashlight-line text-primary-500" aria-hidden="true"></i>
                    讨论度 <strong className="font-semibold text-foreground-900">{formatHeat(t.heat)}</strong>
                  </span>
                  <span className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2.5 py-1 text-xs ${meta.cls}`}>
                    <i className={`${meta.icon} text-sm`} aria-hidden="true"></i>
                    {meta.text}
                  </span>
                </div>
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}